import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {APP_INITIALIZER, importProvidersFrom, LOCALE_ID} from '@angular/core';
import { AuthService } from './app/services/auth';
import { authInterceptor } from './app/utilities/auth.interceptor';
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader} from "@ngx-translate/http-loader";
import {languageInterceptor} from "./app/utilities/language.interceptor";
import {registerLocaleData} from "@angular/common";
import localeEsUS from '@angular/common/locales/es-US';
import localeEsPR from '@angular/common/locales/es-419';
import {LanguageService} from "./app/services/Language.Service";

//Register locale data
registerLocaleData(localeEsUS);
registerLocaleData(localeEsPR);

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptors([
      authInterceptor,
      languageInterceptor
    ])),
    {
      provide: APP_INITIALIZER,
      useFactory: (authService: AuthService) => () => authService.initAuth(),
      deps: [AuthService],
      multi: true
    },
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: { prefix: './assets/i18n/', suffix: '.json' }
    },
    {
      provide: LOCALE_ID,
      useFactory: (languageService: LanguageService) => languageService.currentLang,
      deps: [LanguageService]
    },

    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useClass: TranslateHttpLoader,   // useClass, not useFactory
        },
      })
    ),
  ],
});
